import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import { safeRest } from '../../utils/functions.js';
import { ErrorMsg } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var _excluded = ["id", "errors", "callouts"];

var Errors = function Errors(_ref) {
  var id = _ref.id,
      errors = _ref.errors,
      callouts = _ref.callouts,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var safeProps = safeRest(rest);
  var getErrorContent = errors.map(function (err) {
    return err.isError ? /*#__PURE__*/React.createElement("div", {
      key: err.id
    }, err.msg) : '';
  });

  if (errors && errors.length) {
    return /*#__PURE__*/React.createElement(ErrorMsg, _extends({}, safeProps, {
      id: "".concat(id, "-errors"),
      "aria-atomic": callouts ? 'true' : null,
      "aria-live": callouts ? 'polite' : null,
      role: callouts ? 'alert' : 'none',
      "data-testid": "inline-errors-root",
      theme: theme
    }), getErrorContent);
  }

  return null;
};

process.env.NODE_ENV !== "production" ? Errors.propTypes = {
  /** DOM element ID for form control */
  id: PropTypes.string.isRequired,

  /** sets aria-live to 'polite' and role to 'alert' on error message block  */
  callouts: PropTypes.bool,

  /** Array of error objects */
  errors: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    // error id
    msg: PropTypes.any,
    // localized error text
    isError: PropTypes.bool // error condition

  }))
} : void 0;
Errors.defaultProps = {
  errors: [],
  callouts: false
};
process.env.NODE_ENV !== "production" ? Errors.displayName = 'Errors' : void 0;
var Errors$1 = Errors;

export { Errors$1 as default };
